import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const { accessToken } = useSelector((state) => state.LoginReducer);
  const location = useLocation();

  if (!accessToken) {
    return <Navigate to="/login" state={location.pathname} replace />;
  }

  return children;
}
